import { render, staticRenderFns } from "./ReleaseCreate.vue?vue&type=template&id=034bd7ec&scoped=true&"
import script from "./ReleaseCreate.vue?vue&type=script&lang=js&"
export * from "./ReleaseCreate.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseCreate.vue?vue&type=style&index=0&id=034bd7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bd7ec",
  null
  
)

export default component.exports